import { css } from "@emotion/css";
import palette from "utility/ui/palette";

const styles = {
  icon: css`
    color: ${palette.white};
  `,
};

export default styles;
